import { styles } from './styles';
import { IMembersCountBox } from './types';
import { Box } from '@mui/material';

export const MembersCountBox = ({ count }: IMembersCountBox) => {
  return <Box sx={styles.container}>{count}</Box>;
};
